/**
 * 编辑角色 
 */
import React from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { Modal, Input, message, Form } from 'antd';
import styles from './EditRole.module.scss';

const { TextArea } = Input;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};

class EditRole extends React.Component {

    formRef = React.createRef();
    state = {
        id: '',
        title: this.props.title,
        confirmLoading: false,
    }

    componentDidMount() {
        const { data } = this.props;
        const { id, roleName, remark } = data;
        this.formRef.current.setFieldsValue({ roleName });
        this.formRef.current.setFieldsValue({ remark });
        this.setState({ id });
    }

    // 点击确认
    _handleOk = () => {
        this.formRef.current.validateFields().then((fieldsValue) => {
            const { roleName, remark } = fieldsValue;
            http('/?cmd=com.xqxc.api.pig.mis.biz.account.RoleMisService.updateRole', { id: this.state.id, roleName, remark }, 'POST').then(() => {
                message.success('编辑成功！');
                this.props.closeMode(true);
            }).catch((e) => {
                message.error(e.message);
            });

        });
    }

    // 点击取消
    _handleCancel = () => {
        this.props.closeMode();
    }

    render() {
        const { confirmLoading, title } = this.state;

        return (
            <Modal
                width={900}
                centered
                title={title}
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <Form
                        {...formItemLayout}
                        layout="vertical"
                        ref={this.formRef}
                        initialValues={{ copy: { copyRoleId: undefined, check: false } }}
                        scrollToFirstError
                    >
                        <Form.Item
                            label="角色名称"
                            name="roleName"
                            rules={[
                                { required: true },
                                { max: 20, message: '最多可输入20个字' },
                            ]}>
                            <Input placeholder='请输入角色名称' />
                        </Form.Item>
                        <Form.Item
                            label="角色描述"
                            name="remark"
                            rules={[
                                { max: 200, message: '最多可输入200个字' },
                            ]}>
                            <TextArea rows={4} placeholder="请输入角色描述" />
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        );
    }
}

EditRole.propTypes = {
    data: PropTypes.object, // 弹框入参
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string, // 弹框标题
};

export default EditRole;